// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:global(.height-100) {
    height:100%!important;
}

:global(.width-100) {
  width:100%!important;
}



:global(.icon-white) {
    color: #fff;
}

:global(.col-centered) {
    float: none;
    margin: 0 auto;
}

:global(.pad-10) {
    padding: 10px!important;
}

:global(.pad-5) {
    padding: 5px!important;
}

:global(.margin-5) {
    margin: 5px!important;
}

:global(.margin-2) {
    margin: 2px!important;
}

:global(.margin-35) {
    margin-top: 35px!important;
}

:global(.margin-top-35) {
    margin-top: 35px!important;
}

:global(.margin-top-45) {
    margin-top: 45px!important;
}

:global(.margin-top-20) {
    margin-top: 20px!important;
}

:global(.margin-top-5) {
    margin-top: 5px!important;
}

:global(.margin-bottom-5) {
    margin-bottom: 5px!important;
}

:global(.margin-bottom-20) {
    margin-bottom: 20px!important;
}

:global(.padding-bottom-5) {
    padding-bottom: 5px!important;
}

:global(.padding-bottom-10) {
    padding-bottom: 10px!important;
}

:global(.padding-15) {
    padding: 15px!important;
}

:global(.margin-left-5) {
    margin-left: 5px!important;
}
:global(.margin-left-10) {
    margin-left: 10px!important;
}
:global(.margin-left-15) {
    margin-left: 15px!important;
}
:global(.margin-right-15) {
    margin-right: 15px!important;
}
:global(.margin-right-10) {
    margin-right: 10px!important;
}
:global(.no-margin) {
    margin: 0px!important;
}

:global(.light-text) {
    color: #6a7681;
}
:global(.blue-text) {
    color: #337ab7;
}
:global(.white-text) {
    color: #fff;
}

:global(.lightblue-text) 
{
    color: #9fbdd8;
}

:global(.dark-text) {
    color: #2b3035;
}


:global(.red-text) {
    color: #CC0000;
}

:global(.orange-text) {
    color: #B04C25;
}

.btn-outline-active {
    color: #F5CC52;
    border-color: #F5CC52;
}

.bg-coder-blue {
    background-color: #143852;
}

/* .btn-outline-warning {
    color: rgb(255, 236, 181);
    border-color: rgb(255, 236, 181);
} */


@media screen and (min-width: 768px) {
    /* Remove the padding we set earlier */
    .header,
    .marketing,
    .footer {
        padding-left: 0;
        padding-right: 0;
    }
    /* Space out the masthead */
    .header {
        margin-bottom: 30px;
    }
    /* Remove the bottom border on the jumbotron for visual effect */
    .jumbotron {
        border-bottom: 0;
    }
}


@media (min-width: 768px) {
    .container {
        max-width: 730px;
    }
}

.flexy {
    display: flex;
    flex-direction: column;
}

.flexy-wrapper {
    display: flex;
    flex: 1;
    min-height: 0px;
}

.flexy-content {
    display: flex;
    height: calc(100% - 35px)!important;
    position: relative;
}

.flexy-container {
    height: calc(100% - 5px);
}

body {
    background-color: #ececec;
    padding: 0!important;
    overflow: hidden;
    height: 100%;
    margin: 0;
}

#wrapper {
    width: 100%;
    min-height: 100%;
    height: 100%;
    /* Negative indent footer by its height 
    margin: 0 auto -82px 0;
    Pad bottom by footer height 
    padding: 0 0 80px 0;*/
}

#page-wrapper {
    padding: 8px 15px;
    min-height: 568px;
    background-color: #fff;
}

@media(min-width:768px) {
    #page-wrapper {
        position: inherit;
        margin: 0 0 0 45px;
        padding: 8px 30px;
        border-left: 1px solid #e7e7e7;
    }
}

.navbar-top-links {
    margin-right: 0;
}

.navbar-top-links li {
    display: inline-block;
}

.navbar-top-links li:last-child {
    margin-right: 15px;
}

.navbar-top-links li a {
    padding: 15px;
    min-height: 50px;
}

.navbar-top-links .dropdown-menu li {
    display: block;
}

.navbar-top-links .dropdown-menu li:last-child {
    margin-right: 0;
}

.navbar-top-links .dropdown-menu li a {
    padding: 3px 20px;
    min-height: 0;
}

.navbar-top-links .dropdown-menu li a div {
    white-space: normal;
}

.navbar-top-links .dropdown-messages,
.navbar-top-links .dropdown-tasks,
.navbar-top-links .dropdown-alerts {
    width: 310px;
    min-width: 0;
}

.navbar-top-links .dropdown-messages {
    margin-left: 5px;
}

.navbar-top-links .dropdown-tasks {
    margin-left: -59px;
}

.navbar-top-links .dropdown-alerts {
    margin-left: -123px;
}

.navbar-top-links .dropdown-user {
    right: 0;
    left: auto;
}

.coder-sidebar .coder-sidebar-nav.navbar-collapse {
    padding-right: 0;
    padding-left: 0;
}

.coder-sidebar .coder-sidebar-search {
    padding: 15px;
}

.coder-sidebar ul li {
    border-bottom: 1px solid #e7e7e7;
}

.coder-sidebar ul li a.active {
    background-color: #eee;
}

.coder-sidebar .arrow {
    float: right;
}

.coder-sidebar .fa.arrow:before {
    content: "\\f104";
}

.coder-sidebar .active>a>.fa.arrow:before {
    content: "\\f107";
}

.coder-sidebar .nav-second-level li,
.coder-sidebar .nav-third-level li {
    border-bottom: 0!important;
}

.coder-sidebar .nav-second-level li a {
    padding-left: 37px;
}

.coder-sidebar .nav-third-level li a {
    padding-left: 52px;
}

#sidebar-wrapper {
    width: 50px;
    position: fixed;
    height: 100%;
    z-index: 1000;
  }

@media(min-width:768px) {
    .coder-sidebar {
        z-index: 1;
        position: absolute;
        width: 45px;
    }
    .navbar-top-links .dropdown-messages,
    .navbar-top-links .dropdown-tasks,
    .navbar-top-links .dropdown-alerts {
        margin-left: auto;
    }
}

.btn-outline {
    color: inherit;
    background-color: transparent;
    transition: all .5s;
}

.btn-primary.btn-outline {
    color: #428bca;
}

.btn-success.btn-outline {
    color: #5cb85c;
}

.btn-info.btn-outline {
    color: #5bc0de;
}

.btn-warning.btn-outline {
    color: #f0ad4e;
}

.btn-danger.btn-outline {
    color: #d9534f;
}

.btn-primary.btn-outline:hover,
.btn-success.btn-outline:hover,
.btn-info.btn-outline:hover,
.btn-warning.btn-outline:hover,
.btn-danger.btn-outline:hover {
    color: #fff;
}

.chat {
    margin: 0;
    padding: 0;
    list-style: none;
}

.chat li {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px dotted #999;
}

.chat li.left .chat-body {
    margin-left: 60px;
}

.chat li.right .chat-body {
    margin-right: 60px;
}

.chat li .chat-body p {
    margin: 0;
}

.panel .slidedown .glyphicon,
.chat .glyphicon {
    margin-right: 5px;
}

.chat-panel .panel-body {
    height: 350px;
    overflow-y: scroll;
}

.login-panel {
    margin-top: 25%;
}

.flot-chart {
    display: block;
    height: 400px;
}

.flot-chart-content {
    width: 100%;
    height: 100%;
}

.dataTables_wrapper {
    position: relative;
    clear: both;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
    background: 0 0;
}

table.dataTable thead .sorting_asc:after {
    content: "\\f0de";
    float: right;
    font-family: fontawesome;
}

table.dataTable thead .sorting_desc:after {
    content: "\\f0dd";
    float: right;
    font-family: fontawesome;
}

table.dataTable thead .sorting:after {
    content: "\\f0dc";
    float: right;
    font-family: fontawesome;
    color: rgba(50, 50, 50, .5);
}

.btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.428571429;
}

.btn-circle.btn-lg {
    width: 50px;
    height: 50px;
    padding: 10px 16px;
    border-radius: 25px;
    font-size: 18px;
    line-height: 1.33;
}

.btn-circle.btn-xl {
    width: 70px;
    height: 70px;
    padding: 10px 16px;
    border-radius: 35px;
    font-size: 24px;
    line-height: 1.33;
}

.show-grid [class^=col-] {
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #ddd;
    background-color: #eee!important;
}

.show-grid {
    margin: 15px 0;
}

.huge {
    font-size: 40px;
}

.panel-green {
    border-color: #5cb85c;
}

.panel-green .panel-heading {
    border-color: #5cb85c;
    color: #fff;
    background-color: #5cb85c;
}

.panel-green a {
    color: #5cb85c;
}

.panel-green a:hover {
    color: #3d8b3d;
}

.panel-red {
    border-color: #d9534f;
}

.panel-red .panel-heading {
    border-color: #d9534f;
    color: #fff;
    background-color: #d9534f;
}

.panel-red a {
    color: #d9534f;
}

.panel-red a:hover {
    color: #b52b27;
}

.panel-yellow {
    border-color: #f0ad4e;
}

.panel-yellow .panel-heading {
    border-color: #f0ad4e;
    color: #fff;
    background-color: #f0ad4e;
}

.panel-yellow a {
    color: #f0ad4e;
}

.panel-yellow a:hover {
    color: #df8a13;
}




.hotkey-container {
    height: 100%;
}

/* .version-notes-container removed: the What's New page (/current-version/)
   no longer uses a fixed-height bordered box. See css/release-notes.css. */

.current-version {
    text-align: center;
    font-weight: bold;

}

#current_version {
    color: #b52b27;

}


.font-size-9 {
    font-size: 9px!important;
}


.font-size-10 {
    font-size: 10px!important;
}


.font-size-11 {
    font-size: 11px!important;
}


.font-size-12 {
    font-size: 12px!important;
}


.font-size-13 {
    font-size: 13px!important;
}


.font-size-14 {
    font-size: 14px!important;
}


.font-size-15 {
    font-size: 15px!important;
}
.font-size-16 {
    font-size: 16px!important;
}

.no-padding {
    padding: 0px!important;
}

.padding-5 {
    padding: 5px!important;
}

.app-version-link {
    margin-left: 10px;
}

.header-menu-dropdown {
    overflow-y: initial!important;
}

.app-name-link {
    margin-left: 0!important;
    height: initial!important;
}

.app-nav-right {
    margin-right: 0!important;
}

.app-navbar {
    margin-bottom:0;
    min-height:initial!important;
    padding:0px!important;
}

.app-nav-link {
    margin-left: 10px;
    padding: 5px!important;
}

.navbar-brand-version {
    display: flex;
}

.mouse-pointer {
    cursor: pointer;
}

.no-side-margin{
    margin-left:0px!important;
    margin-right:0px!important;
}


.no-padding{
    padding:0px!important;
}



.center-text{
    text-align:center;
}

.ReactModal__Overlay {
    z-index: 1000;
}

.react-contextmenu-wrapper {
    height: 100%;
}

.header-codeframe-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 350px;
    padding: 0;
}


.react-contexify__item__content {
    padding: 4px 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    text-align: left;
    white-space: nowrap;
    color: #333;
    position: relative; 
}

.drag-handle {
    cursor: move;
}


.Resizer {
  background: #000;
  opacity: 0.2;
  z-index: 1;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-background-clip: padding;
  -webkit-background-clip: padding;
  background-clip: padding-box;
}

.Resizer:hover {
  -webkit-transition: all 2s ease;
  transition: all 2s ease;
}

.Resizer.horizontal {
  height: 11px;
  margin: -5px 0;
  border-top: 5px solid rgba(255, 255, 255, 0);
  border-bottom: 5px solid rgba(255, 255, 255, 0);
  cursor: row-resize;
  width: 100%;
}

.Resizer.horizontal:hover {
  border-top: 5px solid rgba(0, 0, 0, 0.5);
  border-bottom: 5px solid rgba(0, 0, 0, 0.5);
}

.Resizer.vertical {
  width: 13px;
  margin: 0 -5px;
  border-left: 5px solid rgba(255, 255, 255, 0);
  border-right: 5px solid rgba(255, 255, 255, 0);
  cursor: col-resize;
}

.Resizer.vertical:hover {
  border-left: 5px solid rgba(0, 0, 0, 0.5);
  border-right: 5px solid rgba(0, 0, 0, 0.5);
}
.Resizer.disabled {
  cursor: not-allowed;
}
.Resizer.disabled:hover {
  border-color: transparent;
}

.gutter {
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: 50%;
}

.gutter.gutter-horizontal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: col-resize;
}


.gutter.gutter-horizontal:hover {
  cursor: col-resize;
}


.mui-data-grid-row-disabled {
    background-color: #dcdcdc!important;
    text-decoration: line-through;
}

.mui-data-grid-row-active {
    background-color: #fff!important;
}`, "",{"version":3,"sources":["webpack://./logician_coder/static/css/base.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;GAGG;;;AAGH;IACI,sCAAsC;IACtC;;;QAGI,eAAe;QACf,gBAAgB;IACpB;IACA,2BAA2B;IAC3B;QACI,mBAAmB;IACvB;IACA,gEAAgE;IAChE;QACI,gBAAgB;IACpB;AACJ;;;AAGA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ;;;yBAGqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,8BAA8B;IAClC;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;EACf;;AAEF;IACI;QACI,UAAU;QACV,kBAAkB;QAClB,WAAW;IACf;IACA;;;QAGI,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;IAKI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;;;IAKI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;;;AAKA;IACI,YAAY;AAChB;;AAEA;2EAC2E;;AAE3E;IACI,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,cAAc;;AAElB;;;AAGA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;;AAGA;IACI,qBAAqB;AACzB;;;;AAIA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;;AAGA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,4CAA4C;EAC5C,+CAA+C;EAC/C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,yDAA2K;EAC3K,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;IACI,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":["\n:global(.height-100) {\n    height:100%!important;\n}\n\n:global(.width-100) {\n  width:100%!important;\n}\n\n\n\n:global(.icon-white) {\n    color: #fff;\n}\n\n:global(.col-centered) {\n    float: none;\n    margin: 0 auto;\n}\n\n:global(.pad-10) {\n    padding: 10px!important;\n}\n\n:global(.pad-5) {\n    padding: 5px!important;\n}\n\n:global(.margin-5) {\n    margin: 5px!important;\n}\n\n:global(.margin-2) {\n    margin: 2px!important;\n}\n\n:global(.margin-35) {\n    margin-top: 35px!important;\n}\n\n:global(.margin-top-35) {\n    margin-top: 35px!important;\n}\n\n:global(.margin-top-45) {\n    margin-top: 45px!important;\n}\n\n:global(.margin-top-20) {\n    margin-top: 20px!important;\n}\n\n:global(.margin-top-5) {\n    margin-top: 5px!important;\n}\n\n:global(.margin-bottom-5) {\n    margin-bottom: 5px!important;\n}\n\n:global(.margin-bottom-20) {\n    margin-bottom: 20px!important;\n}\n\n:global(.padding-bottom-5) {\n    padding-bottom: 5px!important;\n}\n\n:global(.padding-bottom-10) {\n    padding-bottom: 10px!important;\n}\n\n:global(.padding-15) {\n    padding: 15px!important;\n}\n\n:global(.margin-left-5) {\n    margin-left: 5px!important;\n}\n:global(.margin-left-10) {\n    margin-left: 10px!important;\n}\n:global(.margin-left-15) {\n    margin-left: 15px!important;\n}\n:global(.margin-right-15) {\n    margin-right: 15px!important;\n}\n:global(.margin-right-10) {\n    margin-right: 10px!important;\n}\n:global(.no-margin) {\n    margin: 0px!important;\n}\n\n:global(.light-text) {\n    color: #6a7681;\n}\n:global(.blue-text) {\n    color: #337ab7;\n}\n:global(.white-text) {\n    color: #fff;\n}\n\n:global(.lightblue-text) \n{\n    color: #9fbdd8;\n}\n\n:global(.dark-text) {\n    color: #2b3035;\n}\n\n\n:global(.red-text) {\n    color: #CC0000;\n}\n\n:global(.orange-text) {\n    color: #B04C25;\n}\n\n.btn-outline-active {\n    color: #F5CC52;\n    border-color: #F5CC52;\n}\n\n.bg-coder-blue {\n    background-color: #143852;\n}\n\n/* .btn-outline-warning {\n    color: rgb(255, 236, 181);\n    border-color: rgb(255, 236, 181);\n} */\n\n\n@media screen and (min-width: 768px) {\n    /* Remove the padding we set earlier */\n    .header,\n    .marketing,\n    .footer {\n        padding-left: 0;\n        padding-right: 0;\n    }\n    /* Space out the masthead */\n    .header {\n        margin-bottom: 30px;\n    }\n    /* Remove the bottom border on the jumbotron for visual effect */\n    .jumbotron {\n        border-bottom: 0;\n    }\n}\n\n\n@media (min-width: 768px) {\n    .container {\n        max-width: 730px;\n    }\n}\n\n.flexy {\n    display: flex;\n    flex-direction: column;\n}\n\n.flexy-wrapper {\n    display: flex;\n    flex: 1;\n    min-height: 0px;\n}\n\n.flexy-content {\n    display: flex;\n    height: calc(100% - 35px)!important;\n    position: relative;\n}\n\n.flexy-container {\n    height: calc(100% - 5px);\n}\n\nbody {\n    background-color: #ececec;\n    padding: 0!important;\n    overflow: hidden;\n    height: 100%;\n    margin: 0;\n}\n\n#wrapper {\n    width: 100%;\n    min-height: 100%;\n    height: 100%;\n    /* Negative indent footer by its height \n    margin: 0 auto -82px 0;\n    Pad bottom by footer height \n    padding: 0 0 80px 0;*/\n}\n\n#page-wrapper {\n    padding: 8px 15px;\n    min-height: 568px;\n    background-color: #fff;\n}\n\n@media(min-width:768px) {\n    #page-wrapper {\n        position: inherit;\n        margin: 0 0 0 45px;\n        padding: 8px 30px;\n        border-left: 1px solid #e7e7e7;\n    }\n}\n\n.navbar-top-links {\n    margin-right: 0;\n}\n\n.navbar-top-links li {\n    display: inline-block;\n}\n\n.navbar-top-links li:last-child {\n    margin-right: 15px;\n}\n\n.navbar-top-links li a {\n    padding: 15px;\n    min-height: 50px;\n}\n\n.navbar-top-links .dropdown-menu li {\n    display: block;\n}\n\n.navbar-top-links .dropdown-menu li:last-child {\n    margin-right: 0;\n}\n\n.navbar-top-links .dropdown-menu li a {\n    padding: 3px 20px;\n    min-height: 0;\n}\n\n.navbar-top-links .dropdown-menu li a div {\n    white-space: normal;\n}\n\n.navbar-top-links .dropdown-messages,\n.navbar-top-links .dropdown-tasks,\n.navbar-top-links .dropdown-alerts {\n    width: 310px;\n    min-width: 0;\n}\n\n.navbar-top-links .dropdown-messages {\n    margin-left: 5px;\n}\n\n.navbar-top-links .dropdown-tasks {\n    margin-left: -59px;\n}\n\n.navbar-top-links .dropdown-alerts {\n    margin-left: -123px;\n}\n\n.navbar-top-links .dropdown-user {\n    right: 0;\n    left: auto;\n}\n\n.coder-sidebar .coder-sidebar-nav.navbar-collapse {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.coder-sidebar .coder-sidebar-search {\n    padding: 15px;\n}\n\n.coder-sidebar ul li {\n    border-bottom: 1px solid #e7e7e7;\n}\n\n.coder-sidebar ul li a.active {\n    background-color: #eee;\n}\n\n.coder-sidebar .arrow {\n    float: right;\n}\n\n.coder-sidebar .fa.arrow:before {\n    content: \"\\f104\";\n}\n\n.coder-sidebar .active>a>.fa.arrow:before {\n    content: \"\\f107\";\n}\n\n.coder-sidebar .nav-second-level li,\n.coder-sidebar .nav-third-level li {\n    border-bottom: 0!important;\n}\n\n.coder-sidebar .nav-second-level li a {\n    padding-left: 37px;\n}\n\n.coder-sidebar .nav-third-level li a {\n    padding-left: 52px;\n}\n\n#sidebar-wrapper {\n    width: 50px;\n    position: fixed;\n    height: 100%;\n    z-index: 1000;\n  }\n\n@media(min-width:768px) {\n    .coder-sidebar {\n        z-index: 1;\n        position: absolute;\n        width: 45px;\n    }\n    .navbar-top-links .dropdown-messages,\n    .navbar-top-links .dropdown-tasks,\n    .navbar-top-links .dropdown-alerts {\n        margin-left: auto;\n    }\n}\n\n.btn-outline {\n    color: inherit;\n    background-color: transparent;\n    transition: all .5s;\n}\n\n.btn-primary.btn-outline {\n    color: #428bca;\n}\n\n.btn-success.btn-outline {\n    color: #5cb85c;\n}\n\n.btn-info.btn-outline {\n    color: #5bc0de;\n}\n\n.btn-warning.btn-outline {\n    color: #f0ad4e;\n}\n\n.btn-danger.btn-outline {\n    color: #d9534f;\n}\n\n.btn-primary.btn-outline:hover,\n.btn-success.btn-outline:hover,\n.btn-info.btn-outline:hover,\n.btn-warning.btn-outline:hover,\n.btn-danger.btn-outline:hover {\n    color: #fff;\n}\n\n.chat {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.chat li {\n    margin-bottom: 10px;\n    padding-bottom: 5px;\n    border-bottom: 1px dotted #999;\n}\n\n.chat li.left .chat-body {\n    margin-left: 60px;\n}\n\n.chat li.right .chat-body {\n    margin-right: 60px;\n}\n\n.chat li .chat-body p {\n    margin: 0;\n}\n\n.panel .slidedown .glyphicon,\n.chat .glyphicon {\n    margin-right: 5px;\n}\n\n.chat-panel .panel-body {\n    height: 350px;\n    overflow-y: scroll;\n}\n\n.login-panel {\n    margin-top: 25%;\n}\n\n.flot-chart {\n    display: block;\n    height: 400px;\n}\n\n.flot-chart-content {\n    width: 100%;\n    height: 100%;\n}\n\n.dataTables_wrapper {\n    position: relative;\n    clear: both;\n}\n\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n    background: 0 0;\n}\n\ntable.dataTable thead .sorting_asc:after {\n    content: \"\\f0de\";\n    float: right;\n    font-family: fontawesome;\n}\n\ntable.dataTable thead .sorting_desc:after {\n    content: \"\\f0dd\";\n    float: right;\n    font-family: fontawesome;\n}\n\ntable.dataTable thead .sorting:after {\n    content: \"\\f0dc\";\n    float: right;\n    font-family: fontawesome;\n    color: rgba(50, 50, 50, .5);\n}\n\n.btn-circle {\n    width: 30px;\n    height: 30px;\n    padding: 6px 0;\n    border-radius: 15px;\n    text-align: center;\n    font-size: 12px;\n    line-height: 1.428571429;\n}\n\n.btn-circle.btn-lg {\n    width: 50px;\n    height: 50px;\n    padding: 10px 16px;\n    border-radius: 25px;\n    font-size: 18px;\n    line-height: 1.33;\n}\n\n.btn-circle.btn-xl {\n    width: 70px;\n    height: 70px;\n    padding: 10px 16px;\n    border-radius: 35px;\n    font-size: 24px;\n    line-height: 1.33;\n}\n\n.show-grid [class^=col-] {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border: 1px solid #ddd;\n    background-color: #eee!important;\n}\n\n.show-grid {\n    margin: 15px 0;\n}\n\n.huge {\n    font-size: 40px;\n}\n\n.panel-green {\n    border-color: #5cb85c;\n}\n\n.panel-green .panel-heading {\n    border-color: #5cb85c;\n    color: #fff;\n    background-color: #5cb85c;\n}\n\n.panel-green a {\n    color: #5cb85c;\n}\n\n.panel-green a:hover {\n    color: #3d8b3d;\n}\n\n.panel-red {\n    border-color: #d9534f;\n}\n\n.panel-red .panel-heading {\n    border-color: #d9534f;\n    color: #fff;\n    background-color: #d9534f;\n}\n\n.panel-red a {\n    color: #d9534f;\n}\n\n.panel-red a:hover {\n    color: #b52b27;\n}\n\n.panel-yellow {\n    border-color: #f0ad4e;\n}\n\n.panel-yellow .panel-heading {\n    border-color: #f0ad4e;\n    color: #fff;\n    background-color: #f0ad4e;\n}\n\n.panel-yellow a {\n    color: #f0ad4e;\n}\n\n.panel-yellow a:hover {\n    color: #df8a13;\n}\n\n\n\n\n.hotkey-container {\n    height: 100%;\n}\n\n/* .version-notes-container removed: the What's New page (/current-version/)\n   no longer uses a fixed-height bordered box. See css/release-notes.css. */\n\n.current-version {\n    text-align: center;\n    font-weight: bold;\n\n}\n\n#current_version {\n    color: #b52b27;\n\n}\n\n\n.font-size-9 {\n    font-size: 9px!important;\n}\n\n\n.font-size-10 {\n    font-size: 10px!important;\n}\n\n\n.font-size-11 {\n    font-size: 11px!important;\n}\n\n\n.font-size-12 {\n    font-size: 12px!important;\n}\n\n\n.font-size-13 {\n    font-size: 13px!important;\n}\n\n\n.font-size-14 {\n    font-size: 14px!important;\n}\n\n\n.font-size-15 {\n    font-size: 15px!important;\n}\n.font-size-16 {\n    font-size: 16px!important;\n}\n\n.no-padding {\n    padding: 0px!important;\n}\n\n.padding-5 {\n    padding: 5px!important;\n}\n\n.app-version-link {\n    margin-left: 10px;\n}\n\n.header-menu-dropdown {\n    overflow-y: initial!important;\n}\n\n.app-name-link {\n    margin-left: 0!important;\n    height: initial!important;\n}\n\n.app-nav-right {\n    margin-right: 0!important;\n}\n\n.app-navbar {\n    margin-bottom:0;\n    min-height:initial!important;\n    padding:0px!important;\n}\n\n.app-nav-link {\n    margin-left: 10px;\n    padding: 5px!important;\n}\n\n.navbar-brand-version {\n    display: flex;\n}\n\n.mouse-pointer {\n    cursor: pointer;\n}\n\n.no-side-margin{\n    margin-left:0px!important;\n    margin-right:0px!important;\n}\n\n\n.no-padding{\n    padding:0px!important;\n}\n\n\n\n.center-text{\n    text-align:center;\n}\n\n.ReactModal__Overlay {\n    z-index: 1000;\n}\n\n.react-contextmenu-wrapper {\n    height: 100%;\n}\n\n.header-codeframe-name {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 350px;\n    padding: 0;\n}\n\n\n.react-contexify__item__content {\n    padding: 4px 12px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    text-align: left;\n    white-space: nowrap;\n    color: #333;\n    position: relative; \n}\n\n.drag-handle {\n    cursor: move;\n}\n\n\n.Resizer {\n  background: #000;\n  opacity: 0.2;\n  z-index: 1;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -moz-background-clip: padding;\n  -webkit-background-clip: padding;\n  background-clip: padding-box;\n}\n\n.Resizer:hover {\n  -webkit-transition: all 2s ease;\n  transition: all 2s ease;\n}\n\n.Resizer.horizontal {\n  height: 11px;\n  margin: -5px 0;\n  border-top: 5px solid rgba(255, 255, 255, 0);\n  border-bottom: 5px solid rgba(255, 255, 255, 0);\n  cursor: row-resize;\n  width: 100%;\n}\n\n.Resizer.horizontal:hover {\n  border-top: 5px solid rgba(0, 0, 0, 0.5);\n  border-bottom: 5px solid rgba(0, 0, 0, 0.5);\n}\n\n.Resizer.vertical {\n  width: 13px;\n  margin: 0 -5px;\n  border-left: 5px solid rgba(255, 255, 255, 0);\n  border-right: 5px solid rgba(255, 255, 255, 0);\n  cursor: col-resize;\n}\n\n.Resizer.vertical:hover {\n  border-left: 5px solid rgba(0, 0, 0, 0.5);\n  border-right: 5px solid rgba(0, 0, 0, 0.5);\n}\n.Resizer.disabled {\n  cursor: not-allowed;\n}\n.Resizer.disabled:hover {\n  border-color: transparent;\n}\n\n.gutter {\n  background-color: #eee;\n  background-repeat: no-repeat;\n  background-position: 50%;\n}\n\n.gutter.gutter-horizontal {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');\n  cursor: col-resize;\n}\n\n\n.gutter.gutter-horizontal:hover {\n  cursor: col-resize;\n}\n\n\n.mui-data-grid-row-disabled {\n    background-color: #dcdcdc!important;\n    text-decoration: line-through;\n}\n\n.mui-data-grid-row-active {\n    background-color: #fff!important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
